// API Configuration
const API_BASE_URL = 'https://jumper-game.vizua.sk/api';

// Language Configuration
const lang = 'hr'; // Change to: 'sk', 'cs', 'hu', 'en', 'hr'

// Test Mode Configuration
const TEST_MODE_ENABLED = false; // Set to true to enable test mode (flying), false to disable

// Translations
const translations = {
    sk: {
        gameTitle: "Techsavers Renovator",
        logoUrl: "https://cdn.shopify.com/s/files/1/0703/7190/1665/files/logo-uvod-hra-SK.png?v=1764841364",
        subtitle: "Staňte sa na chvíľu súčasťou našej vianočnej renovačnej továrne.",
        instructions: "Skáčte po plošinách, zbierajte predmety a prejdite všetkými 11 krokmi renovácie!",
        controls: "Ovládanie: šípky doľava a doprava na pohyb, medzerník na skok.",
        playGame: "Hrať hru",
        score: "SKÓRE",
        level: "ÚROVEŇ",
        gameOver: "Koniec hry",
        achievedScore: "Dosiahnuté skóre:",
        yourName: "Tvoje meno / prezývka",
        submitScore: "Odoslať skóre",
        tryAgain: "Skúsiť znova",
        congratulations: "👏 Gratulujeme!",
        completedAllSteps: "Prešli ste všetkých 11 krokov renovácie.",
        thanksMessage: "Vďaka vám budú tieto Vianoce plné techniky, ktorá vydrží a má zelené srdce. 💚",
        yourBonus: "Váš vianočný bonus:",
        discountInfo: "🎁 Získavate 5 % zľavu pri nákupe nad 200 €.",
        discountCode: "Váš zľavový kupón:",
        loading: "Načítavam...",
        playAgain: "Hrať znova",
        leaderboard: "Rebríček najlepších",
        finish: "CIEĽ",
        back: "Späť",
        noScores: "Zatiaľ žiadne skóre.",
        combo: "Combo",
        levels: [
            "Naskladnenie produktov",
            "Profylaxia (základná kontrola)",
            "Prvotné roztriedenie podľa stavu",
            "Zásahy podľa stavu (opravy)",
            "Testy a inštalácia",
            "Zaradenie do výstupných kategórií",
            "Čistenie a balenie",
            "Predaj",
            "Potlač novej lokalizovanej klávesnice",
            "Záverečné čistenie a balenie",
            "Expedícia"
        ]
    },
    cs: {
        gameTitle: "Techsavers Renovator",
        logoUrl: "https://cdn.shopify.com/s/files/1/0904/6160/2176/files/logo-uvod-hra-CZ.png?v=1764841201",
        subtitle: "Staňte se na chvíli součástí naší vánoční renovační továrny.",
        instructions: "Skákejte po plošinách, sbírejte předměty a projděte všemi 11 kroky renovace!",
        controls: "Ovládání: šipky doleva a doprava na pohyb, mezerník na skok.",
        playGame: "Hrát hru",
        score: "SKÓRE",
        level: "ÚROVEŇ",
        gameOver: "Konec hry",
        achievedScore: "Dosažené skóre:",
        yourName: "Tvoje jméno / přezdívka",
        submitScore: "Odeslat skóre",
        tryAgain: "Zkusit znova",
        congratulations: "👏 Gratulujeme!",
        completedAllSteps: "Prošli jste všemi 11 kroky renovace.",
        thanksMessage: "Díky vám budou tyto Vánoce plné techniky, která vydrží a má zelené srdce. 💚",
        yourBonus: "Váš vánoční bonus:",
        discountInfo: "🎁 Získáváte 5 % slevu při nákupu nad 5 000 Kč.",
        discountCode: "Váš slevový kupón:",
        loading: "Načítám...",
        playAgain: "Hrát znova",
        leaderboard: "Žebříček nejlepších",
        finish: "CÍL",
        back: "Zpět",
        noScores: "Zatím žádné skóre.",
        combo: "Combo",
        levels: [
            "Naskladnění produktů",
            "Profylaxe (základní kontrola)",
            "Prvotní roztřídění podle stavu",
            "Zásahy podle stavu (opravy)",
            "Testy a instalace",
            "Zařazení do výstupních kategorií",
            "Čištění a balení",
            "Prodej",
            "Potisk nové lokalizované klávesnice",
            "Závěrečné čištění a balení",
            "Expedice"
        ]
    },
    hu: {
        gameTitle: "Techsavers Renovator",
        logoUrl: "https://cdn.shopify.com/s/files/1/0930/1691/6233/files/logo-uvod-hra-HU.png?v=1764841281",
        subtitle: "Légy részese egy pillanatra karácsonyi felújítási gyárunknak.",
        instructions: "Ugrálj a platformokon, gyűjts tárgyakat és menj át mind a 11 felújítási lépésen!",
        controls: "Irányítás: bal és jobb nyilak a mozgáshoz, szóköz az ugráshoz.",
        playGame: "Játék indítása",
        score: "PONTSZÁM",
        level: "SZINT",
        gameOver: "Játék vége",
        achievedScore: "Elért pontszám:",
        yourName: "Neved / beceneved",
        submitScore: "Pontszám beküldése",
        tryAgain: "Próbáld újra",
        congratulations: "👏 Gratulálunk!",
        completedAllSteps: "Átmentél mind a 11 felújítási lépésen.",
        thanksMessage: "Köszönhetően neked ezek a karácsonyok tele lesznek olyan technikával, amely kitart és zöld szíve van. 💚",
        yourBonus: "Karácsonyi bónuszod:",
        discountInfo: "🎁 5%-os kedvezményt kapsz 79 800 Ft feletti vásárlásnál.",
        discountCode: "Kedvezményes kuponod:",
        loading: "Betöltés...",
        playAgain: "Játssz újra",
        leaderboard: "Ranglista",
        finish: "CÉL",
        back: "Vissza",
        noScores: "Még nincs pontszám.",
        combo: "Kombó",
        levels: [
            "Termékek raktározása",
            "Profilaxis (alapellenőrzés)",
            "Előzetes rendezés állapot szerint",
            "Beavatkozások állapot szerint (javítások)",
            "Tesztek és telepítés",
            "Besorolás kimeneti kategóriákba",
            "Tisztítás és csomagolás",
            "Értékesítés",
            "Új lokalizált billentyűzet nyomtatása",
            "Végső tisztítás és csomagolás",
            "Szállítás"
        ]
    },
    en: {
        gameTitle: "Techsavers Renovator",
        logoUrl: "https://cdn.shopify.com/s/files/1/0606/7981/5267/files/logo-uvod-hra-EN.png?v=1764841319",
        subtitle: "Become part of our Christmas renovation factory for a moment.",
        instructions: "Jump on platforms, collect items and complete all 11 renovation steps!",
        controls: "Controls: left and right arrow keys to move, space to jump.",
        playGame: "Play Game",
        score: "SCORE",
        level: "LEVEL",
        gameOver: "Game Over",
        achievedScore: "Your Score:",
        yourName: "Your name / nickname",
        submitScore: "Submit Score",
        tryAgain: "Try Again",
        congratulations: "👏 Congratulations!",
        completedAllSteps: "You completed all 11 renovation steps.",
        thanksMessage: "Thanks to you, this Christmas will be full of technology that lasts and has a green heart. 💚",
        yourBonus: "Your Christmas bonus:",
        discountInfo: "🎁 You get a 5% discount on purchases over €200.",
        discountCode: "Your discount coupon:",
        loading: "Loading...",
        playAgain: "Play Again",
        leaderboard: "Leaderboard",
        finish: "FINISH",
        back: "Back",
        noScores: "No scores yet.",
        combo: "Combo",
        levels: [
            "Product Stocking",
            "Prophylaxis (basic check)",
            "Initial Sorting by Condition",
            "Interventions by Condition (repairs)",
            "Testing and Installation",
            "Classification into Output Categories",
            "Cleaning and Packaging",
            "Sales",
            "New Localized Keyboard Printing",
            "Final Cleaning and Packaging",
            "Shipping"
        ]
    },
    hr: {
        gameTitle: "Techsavers Renovator",
        logoUrl: "https://cdn.shopify.com/s/files/1/0939/4428/3475/files/logo-uvod-hra-HR.png?v=1764841247",
        subtitle: "Postanite na trenutak dio naše božićne renovacijske tvornice.",
        instructions: "Skačite po platformama, skupljajte predmete i prođite svih 11 koraka renovacije!",
        controls: "Kontrole: strelice lijevo i desno za kretanje, razmaknica za skok.",
        playGame: "Igraj igru",
        score: "REZULTAT",
        level: "RAZINA",
        gameOver: "Kraj igre",
        achievedScore: "Postignuti rezultat:",
        yourName: "Tvoje ime / nadimak",
        submitScore: "Pošalji rezultat",
        tryAgain: "Pokušaj ponovno",
        congratulations: "👏 Čestitamo!",
        completedAllSteps: "Prošli ste svih 11 koraka renovacije.",
        thanksMessage: "Zahvaljujući vama, ovaj Božić će biti pun tehnologije koja traje i ima zeleno srce. 💚",
        yourBonus: "Vaš božićni bonus:",
        discountInfo: "🎁 Dobivate 5% popusta na kupnju iznad 200 €.",
        discountCode: "Vaš kupon za popust:",
        loading: "Učitavam...",
        playAgain: "Igraj ponovno",
        leaderboard: "Najbolji igrači",
        finish: "CILJ",
        back: "Natrag",
        noScores: "Još nema rezultata.",
        combo: "Combo",
        levels: [
            "Uskladištenje proizvoda",
            "Profilaksa (osnovna provjera)",
            "Početno razvrstavanje po stanju",
            "Intervencije prema stanju (popravci)",
            "Testiranje i instalacija",
            "Razvrstavanje u izlazne kategorije",
            "Čišćenje i pakiranje",
            "Prodaja",
            "Ispis nove lokalizirane tipkovnice",
            "Konačno čišćenje i pakiranje",
            "Otprema"
        ]
    }
};

function t(key) {
    return translations[lang][key] || key;
}

// Game Constants
const CANVAS_WIDTH = 400;
const CANVAS_HEIGHT = 600; // Adjusted for top panel
const GRAVITY = 0.6;
const FRICTION = 0.85;
const ACCELERATION = 0.5; // Reduced for better control
const JUMP_FORCE = -16;
const MAX_SPEED = 12; // Cap horizontal speed
const WALL_JUMP_FORCE_X = 10;
const WALL_JUMP_FORCE_Y = -14;

// Game State
let canvas, ctx;
let lastTime = 0;
let gameRunning = false;
let score = 0;
let combo = 0;
let cameraY = 0;
let currentLevelIndex = 0;
let collectedItems = 0;
let lastComboTime = 0;
let keys = {
    ArrowLeft: false,
    ArrowRight: false,
    ArrowUp: false,
    ArrowDown: false,
    Space: false
};
let jumpReady = true;
let testMode = false;

// Level Data
const LEVELS = [
    {
        nameKey: 0,
        color: "#3498db",
        collectibles: ["📦", "💻", "🖥️", "🖨️"],
        height: 0
    },
    {
        nameKey: 1,
        color: "#e67e22",
        collectibles: ["🔍", "🧰", "⚙️", "📝"],
        height: 1000
    },
    {
        nameKey: 2,
        color: "#f1c40f",
        collectibles: ["🟢", "🟡", "🔴"],
        height: 2000
    },
    {
        nameKey: 3,
        color: "#e74c3c",
        collectibles: ["🔧", "🪛", "🧩", "🧪"],
        height: 3000
    },
    {
        nameKey: 4,
        color: "#9b59b6",
        collectibles: ["💾", "🔋", "⚡", "🖥️", "🛡️"],
        height: 4000
    },
    {
        nameKey: 5,
        color: "#1abc9c",
        collectibles: ["⭐", "🟩", "🟨", "🟧"],
        height: 5000
    },
    {
        nameKey: 6,
        color: "#2ecc71",
        collectibles: ["🧼", "🔋", "♻️", "🎁"],
        height: 6000
    },
    {
        nameKey: 7,
        color: "#34495e",
        collectibles: ["🛒", "💳", "📲", "⭐"],
        height: 7000
    },
    {
        nameKey: 8,
        color: "#95a5a6",
        collectibles: ["⌨️", "🔠", "🖨️", "🖋️"],
        height: 8000
    },
    {
        nameKey: 9,
        color: "#d35400",
        collectibles: ["🧤", "🪮", "📦", "✨"],
        height: 9000
    },
    {
        nameKey: 10,
        color: "#8e44ad",
        collectibles: ["🚚", "📦", "🗺️", "📮"],
        height: 10000
    }
];

const WIN_HEIGHT = 11000;

// Game Objects
const player = {
    x: CANVAS_WIDTH / 2,
    y: CANVAS_HEIGHT - 100,
    width: 65, // Increased by 30% (from 50)
    height: 65, // Increased by 30% (from 50)
    vx: 0,
    vy: 0,
    onGround: false,
    color: '#ecf0f1',
    // Animation State
    state: 'idle', // idle, run, jump, dead
    facing: 'right',
    frame: 0,
    frameTimer: 0,
    animationSpeed: 0.05 // 20fps roughly
};

let platforms = [];
let particles = [];
let snowflakes = [];

// Sprites
let spriteSheet = null;
const SPRITE_CELL_WIDTH = 278;
const SPRITE_CELL_HEIGHT = 277;
const spriteData = {
    jump: { row: 0, frames: 5 },
    run: { row: 1, frames: 6 },
    idle: { row: 2, frames: 2 }
};

// DataLayer Helper Function
function pushDataLayerEvent(eventName, eventLabel) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': eventName,
        'event_category': 'game',
        'event_label': eventLabel
    });
}

// Initialization
window.onload = function() {
    loadSprites();
    
    canvas = document.getElementById('gameCanvas');
    ctx = canvas.getContext('2d');
    canvas.width = CANVAS_WIDTH;
    canvas.height = CANVAS_HEIGHT;

    // Initialize UI with translations
    initializeTranslations();

    // Event Listeners
    window.addEventListener('keydown', (e) => {
        // Prevent default behavior for arrow keys and space
        if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space"].includes(e.code)) {
            e.preventDefault();
        }

        if (e.code === 'Space') {
            if (jumpReady) {
                keys.Space = true;
                jumpReady = false;
            }
        }
        if (e.code === 'ArrowLeft') keys.ArrowLeft = true;
        if (e.code === 'ArrowRight') keys.ArrowRight = true;
        if (e.code === 'ArrowUp') keys.ArrowUp = true;
        if (e.code === 'ArrowDown') keys.ArrowDown = true;
        if (e.code === 'KeyT' && TEST_MODE_ENABLED) {
            testMode = !testMode;
            if (testMode) {
                console.log("Test Mode ON");
                updateHUD(); // Immediately show test status
            } else {
                console.log("Test Mode OFF");
                // Reset velocity to avoid flinging
                player.vx = 0;
                player.vy = 0;
                updateHUD();
            }
        }
    });

    window.addEventListener('keyup', (e) => {
        if (e.code === 'Space') {
            keys.Space = false;
            jumpReady = true;
        }
        if (e.code === 'ArrowLeft') keys.ArrowLeft = false;
        if (e.code === 'ArrowRight') keys.ArrowRight = false;
        if (e.code === 'ArrowUp') keys.ArrowUp = false;
        if (e.code === 'ArrowDown') keys.ArrowDown = false;
    });

    document.getElementById('start-btn').addEventListener('click', () => {
        pushDataLayerEvent('game_action', 'initial_start');
        startGame();
    });
    document.getElementById('restart-btn').addEventListener('click', () => {
        pushDataLayerEvent('game_action', 'restart_after_game_over');
        startGame();
    });
    document.getElementById('play-again-btn').addEventListener('click', () => {
        pushDataLayerEvent('game_action', 'restart_after_win');
        startGame();
    });
    const shareBtn = document.getElementById('share-btn');
    if (shareBtn) {
        shareBtn.addEventListener('click', shareResult);
    }
    
    // API Buttons
    document.getElementById('submit-score-btn').addEventListener('click', (e) => {
        e.preventDefault();
        submitScore(document.getElementById('nickname-input').value, 'submit-score-btn');
    });
    document.getElementById('win-submit-score-btn').addEventListener('click', (e) => {
        e.preventDefault();
        submitScore(document.getElementById('win-nickname-input').value, 'win-submit-score-btn');
    });
    document.getElementById('scoreboard-back-btn').addEventListener('click', hideScoreboard);
    
    // Touch Controls
    setupTouchControls();
};

function setupTouchControls() {
    const btnLeft = document.getElementById('btn-left');
    const btnRight = document.getElementById('btn-right');
    const btnJump = document.getElementById('btn-jump');
    
    const handleTouch = (btn, key, isPressed) => {
        btn.addEventListener(isPressed ? 'touchstart' : 'touchend', (e) => {
            e.preventDefault();
            if (key === 'Space') {
                if (isPressed) {
                    if (jumpReady) {
                        keys.Space = true;
                        jumpReady = false;
                    }
                } else {
                    keys.Space = false;
                    jumpReady = true;
                }
            } else {
                keys[key] = isPressed;
            }
        });
        
        // Mouse fallback for testing on desktop
        btn.addEventListener(isPressed ? 'mousedown' : 'mouseup', (e) => {
            e.preventDefault();
            if (key === 'Space') {
                if (isPressed) {
                    if (jumpReady) {
                        keys.Space = true;
                        jumpReady = false;
                    }
                } else {
                    keys.Space = false;
                    jumpReady = true;
                }
            } else {
                keys[key] = isPressed;
            }
        });
    };

    handleTouch(btnLeft, 'ArrowLeft', true);
    handleTouch(btnLeft, 'ArrowLeft', false);
    
    handleTouch(btnRight, 'ArrowRight', true);
    handleTouch(btnRight, 'ArrowRight', false);
    
    handleTouch(btnJump, 'Space', true);
    handleTouch(btnJump, 'Space', false);
}

function initializeTranslations() {
    // Update HTML elements with translations
    const logo = document.getElementById('game-logo');
    logo.src = t('logoUrl');
    logo.alt = t('gameTitle');
    document.getElementById('subtitle-text').textContent = t('subtitle');
    document.querySelector('#start-screen p:nth-of-type(2)').textContent = t('instructions');
    document.querySelector('#start-screen p:nth-of-type(3)').textContent = t('controls');
    document.getElementById('start-btn').textContent = t('playGame');
    
    document.querySelector('#game-over-screen h2').textContent = t('gameOver');
    document.querySelector('#game-over-screen p:first-of-type').innerHTML = t('achievedScore') + ' <span id="final-score">0</span>';
    document.getElementById('nickname-input').placeholder = t('yourName');
    document.getElementById('submit-score-btn').textContent = t('submitScore');
    document.getElementById('restart-btn').textContent = t('tryAgain');
    
    document.querySelector('#win-screen h2').textContent = t('congratulations');
    document.querySelector('#win-screen p:nth-of-type(1)').textContent = t('completedAllSteps');
    document.querySelector('#win-screen p:nth-of-type(2)').innerHTML = t('achievedScore') + ' <span id="win-final-score">0</span>';
    document.getElementById('win-nickname-input').placeholder = t('yourName');
    document.getElementById('win-submit-score-btn').textContent = t('submitScore');
    document.getElementById('play-again-btn').textContent = t('playAgain');
    
    document.querySelector('#scoreboard-screen h2').textContent = t('leaderboard');
    document.querySelector('#scoreboard-list p').textContent = t('loading');
    document.getElementById('scoreboard-back-btn').textContent = t('back');
    
    document.querySelector('.score-section .label').textContent = t('score');
    document.querySelector('.level-section .label').innerHTML = t('level') + ' <span id="level">1</span>';
    
    // Initialize level name with first level
    document.getElementById('level-name').textContent = t('levels')[0];
    
    // Discount container translations
    document.getElementById('discount-info-text').textContent = t('discountInfo');
    document.getElementById('discount-code-label').innerHTML = t('discountCode') + ' <strong id="discount-code">' + t('loading') + '</strong>';
}

function loadSprites() {
    spriteSheet = new Image();
    spriteSheet.src = 'https://cdn.shopify.com/s/files/1/0703/7190/1665/files/sprite_santa.png?v=1764753366';
}

function startGame() {
    // Reset Game State
    gameRunning = true;
    score = 0;
    combo = 0;
    cameraY = 0;
    currentLevelIndex = 0;
    collectedItems = 0;
    
    // Reset Player
    player.x = CANVAS_WIDTH / 2 - player.width / 2;
    player.y = CANVAS_HEIGHT - 100;
    player.vx = 0;
    player.vy = 0;
    player.onGround = true;
    player.state = 'idle';

    // Reset Platforms
    platforms = [];
    // Ground platform
    platforms.push({
        x: 0,
        y: CANVAS_HEIGHT - 20,
        width: CANVAS_WIDTH,
        height: 20,
        type: 'ground',
        visited: true
    });

    // Generate initial platforms
    generatePlatforms(0);
    
    // Initialize Snowflakes
    snowflakes = [];
    for(let i=0; i<100; i++) {
        snowflakes.push({
            x: Math.random() * CANVAS_WIDTH,
            y: Math.random() * CANVAS_HEIGHT,
            r: Math.random() * 3 + 1,
            d: Math.random() * 100 // density
        });
    }

    // Hide screens, show HUD
    document.getElementById('start-screen').classList.add('hidden');
    document.getElementById('game-over-screen').classList.add('hidden');
    document.getElementById('win-screen').classList.add('hidden');
    document.getElementById('scoreboard-screen').classList.add('hidden');
    document.getElementById('hud').classList.remove('hidden');
    
    // Reset forms
    document.getElementById('nickname-input').value = '';
    document.getElementById('win-nickname-input').value = '';
    document.getElementById('submission-form').classList.remove('hidden');
    document.getElementById('win-submission-form').classList.remove('hidden');

    lastTime = performance.now();
    requestAnimationFrame(gameLoop);
}

function generatePlatforms(startY) {
    let y = startY;
    
    const lastPlatformY = platforms.length > 0 ? platforms[platforms.length - 1].y : CANVAS_HEIGHT;
    
    // Generate chunk
    let currentY = lastPlatformY;
    while (currentY > -(cameraY + CANVAS_HEIGHT * 2)) {
        // Check if we reached the finish line height
        if (CANVAS_HEIGHT - currentY >= WIN_HEIGHT) {
            // Add finish line platform if not added yet
            if (!platforms.some(p => p.type === 'finish')) {
                platforms.push({
                    x: 0,
                    y: currentY - 100, // Put it clearly at the end
                    width: CANVAS_WIDTH,
                    height: 40,
                    type: 'finish',
                    color: '#FFD700', // Gold
                    visited: false
                });
            }
            break; // Stop generating more platforms
        }

        currentY -= 100 + Math.random() * 60; // Increased gap (100-160)
        
        const width = 50 + Math.random() * 60; // Narrower platforms (50-110)
        const x = Math.random() * (CANVAS_WIDTH - width);
        
        // Determine level based on height (inverted Y)
        const height = CANVAS_HEIGHT - currentY;
        const levelIdx = getLevelIndex(height);
        const levelData = LEVELS[levelIdx];
        
        // Add collectible?
        let collectible = null;
        if (Math.random() > 0.3) {
            const item = levelData.collectibles[Math.floor(Math.random() * levelData.collectibles.length)];
            collectible = {
                item: item,
                collected: false
            };
        }

        // Ensure platform fits within new width
        const maxPlatformWidth = CANVAS_WIDTH - 20; 
        const adjustedWidth = Math.min(width, maxPlatformWidth);
        const adjustedX = Math.min(x, CANVAS_WIDTH - adjustedWidth);

        platforms.push({
            x: adjustedX,
            y: currentY,
            width: adjustedWidth,
            height: 15,
            color: levelData.color,
            collectible: collectible,
            visited: false,
            id: Math.random()
        });
    }
}

function getLevelIndex(height) {
    for (let i = LEVELS.length - 1; i >= 0; i--) {
        if (height >= LEVELS[i].height) {
            return i;
        }
    }
    return 0;
}

function gameLoop(timestamp) {
    if (!gameRunning) return;

    const dt = (timestamp - lastTime) / 16.67; // Normalize to ~60fps
    lastTime = timestamp;

    update(dt);
    draw();
    drawSnow(); // Draw snow on top

    requestAnimationFrame(gameLoop);
}

function update(dt) {
    // Update Snow
    snowflakes.forEach(f => {
        f.y += Math.pow(f.d, 0.5) * 0.05 * dt; // Fall speed
        f.x += Math.sin(lastTime * 0.001) * 0.5; // Sway

        if (f.y > CANVAS_HEIGHT) {
            f.y = -10;
            f.x = Math.random() * CANVAS_WIDTH;
        }
        if (f.x > CANVAS_WIDTH) f.x = 0;
        if (f.x < 0) f.x = CANVAS_WIDTH;
    });

    if (testMode) {
        // Test Mode Physics (Flying)
        const speed = 15;
        player.vx = 0;
        player.vy = 0;
        
        if (keys.ArrowLeft) player.vx = -speed;
        if (keys.ArrowRight) player.vx = speed;
        if (keys.ArrowUp) player.vy = -speed;
        if (keys.ArrowDown) player.vy = speed;
        
        player.x += player.vx * dt;
        player.y += player.vy * dt;
        
        const targetCamY = CANVAS_HEIGHT / 2 - player.y;
        if (targetCamY > 0) cameraY = targetCamY;
        
    } else {
        // Normal Physics
        // Horizontal Movement
        if (keys.ArrowLeft) {
            player.vx -= ACCELERATION * dt;
        } else if (keys.ArrowRight) {
            player.vx += ACCELERATION * dt;
        } else {
            // Friction
            player.vx *= FRICTION;
        }

        // Clamp speed
        if (Math.abs(player.vx) > MAX_SPEED) {
            player.vx = Math.sign(player.vx) * MAX_SPEED;
        }

        player.x += player.vx * dt;

        // Wall collisions (slide/stop)
        if (player.x < 0) {
            player.x = 0;
            player.vx = 0; 
        } else if (player.x + player.width > CANVAS_WIDTH) {
            player.x = CANVAS_WIDTH - player.width;
            player.vx = 0;
        }

        // Gravity
        player.vy += GRAVITY * dt;
        player.y += player.vy * dt;

        // Jumping
        if (keys.Space) {
            let jumped = false;
            if (player.onGround) {
                player.vy = JUMP_FORCE;
                player.onGround = false;
                player.vy -= Math.abs(player.vx) * 0.2; 
                jumped = true;
            } else if (player.x <= 0) {
                player.vy = WALL_JUMP_FORCE_Y;
                player.vx = WALL_JUMP_FORCE_X;
                jumped = true;
            } else if (player.x + player.width >= CANVAS_WIDTH) {
                player.vy = WALL_JUMP_FORCE_Y;
                player.vx = -WALL_JUMP_FORCE_X;
                jumped = true;
            }
            
            if (jumped) {
                 keys.Space = false; // Force release to jump again
            }
        }

        // Collision with Platforms
        player.onGround = false;
        // Only check collision if falling
        if (player.vy > 0) {
            for (let plat of platforms) {
                if (
                    player.x + player.width > plat.x &&
                    player.x < plat.x + plat.width
                ) {
                    const prevBottom = player.y - player.vy * dt + player.height;
                    const currBottom = player.y + player.height;
                    
                    if (prevBottom <= plat.y + 5 && currBottom >= plat.y) {
                        // Landed
                        player.y = plat.y - player.height;
                        player.vy = 0;
                        player.onGround = true;
                        
                        // Combo / Score logic
                        if (!plat.visited && plat.type !== 'ground') {
                            plat.visited = true;
                            score += 10 * (combo + 1);
                            combo++;
                            document.getElementById('combo-container').innerText = `${t('combo')} x${combo}`;
                            document.getElementById('combo-container').classList.remove('hidden');
                            
                            setTimeout(() => {
                                if (performance.now() - lastComboTime > 1000) {
                                    document.getElementById('combo-container').classList.add('hidden');
                                    combo = 0; 
                                }
                            }, 1500);
                            lastComboTime = performance.now();
                        }
                        
                        // Collectible
                        if (plat.collectible && !plat.collectible.collected) {
                            plat.collectible.collected = true;
                            score += 50;
                            collectedItems++;
                            createParticles(plat.x + plat.width/2, plat.y, plat.collectible.item);
                        }
                    }
                }
            }
        } else {
            // Reset combo logic if needed
        }

        // Camera movement
        const currentHeight = CANVAS_HEIGHT - player.y;
        
        const targetCameraY = Math.max(0, currentHeight - CANVAS_HEIGHT / 2);
        // Smooth camera
        if (targetCameraY > cameraY) {
            cameraY += (targetCameraY - cameraY) * 0.1 * dt;
        }
        
        // Auto-scroll mechanic
        if (cameraY > 200) {
            cameraY += (1.0 + (cameraY / 7000)) * dt; // Normalized by frame rate
        }
    }
    
    // Animation Update
    if (!gameRunning && player.state === 'dead') {
         updateAnimation(dt);
    } else if (gameRunning) {
        // Determine State
        if (!player.onGround) {
            player.state = 'jump';
        } else {
            if (Math.abs(player.vx) > 0.1) {
                player.state = 'run';
            } else {
                player.state = 'idle';
            }
        }
        
        // Determine Facing
        if (player.vx > 0) player.facing = 'right';
        if (player.vx < 0) player.facing = 'left';
        
        updateAnimation(dt);
    }

    // Check Game Over (Falling off screen)
    if (player.y > CANVAS_HEIGHT - cameraY + 100) {
        if (player.state !== 'dead') { 
             gameOver();
        }
    }

    // Generate more platforms
    generatePlatforms(-cameraY);

    // Remove old platforms
    platforms = platforms.filter(p => p.y > -(cameraY + CANVAS_HEIGHT * 2) && p.y < CANVAS_HEIGHT - cameraY + 200);

    // Update Level
    const newLevelIdx = getLevelIndex(cameraY);
    if (newLevelIdx !== currentLevelIndex) {
        currentLevelIndex = newLevelIdx;
        updateHUD();
    }
    
    // Check Win Condition
    const finishPlat = platforms.find(p => p.type === 'finish');
    if (finishPlat) {
        if (player.y < finishPlat.y) {
            winGame();
        }
    }
    
    // Fallback win
    if (cameraY >= WIN_HEIGHT + 500) {
        winGame();
    }

    updateHUD();
}

function updateHUD() {
    document.getElementById('score').innerText = Math.floor(score);
    const levelData = LEVELS[currentLevelIndex];
    document.getElementById('level').innerText = currentLevelIndex + 1;
    const levelName = t('levels')[levelData.nameKey];
    if (testMode) {
        document.getElementById('level-name').innerText = levelName + " [TEST]";
    } else {
        document.getElementById('level-name').innerText = levelName;
    }
    // document.getElementById('level-name').style.color = levelData.color; // Removed color override to keep it white
}

function draw() {
    ctx.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);

    ctx.save();
    ctx.translate(0, cameraY);

    // Draw Platforms
    platforms.forEach(plat => {
        if (plat.type === 'finish') {
            // Draw Finish Line
            ctx.fillStyle = plat.color;
            ctx.fillRect(plat.x, plat.y, plat.width, plat.height);
            
            // Draw Checkered Pattern
            const checkSize = 20;
            ctx.fillStyle = '#000';
            for (let i = 0; i < plat.width; i += checkSize) {
                for (let j = 0; j < plat.height; j += checkSize) {
                    if ((i / checkSize + j / checkSize) % 2 === 0) {
                        ctx.fillRect(plat.x + i, plat.y + j, checkSize, checkSize);
                    }
                }
            }
            
            // Draw Text
            ctx.fillStyle = '#FFF';
            ctx.font = 'bold 30px Arial';
            ctx.textAlign = 'center';
            ctx.fillText(t('finish'), plat.x + plat.width / 2, plat.y - 10);
            return;
        }

        ctx.fillStyle = plat.color || '#fff';
        ctx.fillRect(plat.x, plat.y, plat.width, plat.height);
        
        // Draw Snow on Platform
        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.rect(plat.x, plat.y, plat.width, 5); // Top layer
        ctx.fill();
        
        // Add some drips
        if (plat.width > 20) {
            ctx.beginPath();
            ctx.arc(plat.x + 10, plat.y + 5, 5, 0, Math.PI);
            ctx.fill();
            ctx.beginPath();
            ctx.arc(plat.x + plat.width - 10, plat.y + 5, 4, 0, Math.PI);
            ctx.fill();
        }

        // Draw Collectible
        if (plat.collectible && !plat.collectible.collected) {
            ctx.font = '24px Arial';
            ctx.textAlign = 'center';
            ctx.fillText(plat.collectible.item, plat.x + plat.width / 2, plat.y - 5);
        }
    });

    // Draw Player
    const spriteInfo = spriteData[player.state];
    if (spriteSheet && spriteSheet.complete && spriteInfo) {
        const frameIndex = player.frame % spriteInfo.frames;
        
        // Source coordinates in sprite sheet
        const sx = frameIndex * SPRITE_CELL_WIDTH;
        const sy = spriteInfo.row * SPRITE_CELL_HEIGHT;
        
        ctx.save();
        
        const centerX = player.x + player.width / 2;
        const centerY = player.y + player.height / 2;
        
        ctx.translate(centerX, centerY);
        
        if (player.facing === 'left') {
            ctx.scale(-1, 1);
        }
        
        const drawSize = 104; // Increased by 30% (from 80)
        ctx.drawImage(
            spriteSheet, 
            sx, sy, SPRITE_CELL_WIDTH, SPRITE_CELL_HEIGHT,
            -drawSize/2, -drawSize/2 - 5, drawSize, drawSize
        ); 
        
        ctx.restore();
    } else {
        // Fallback
        ctx.fillStyle = player.color;
        ctx.fillRect(player.x, player.y, player.width, player.height);
    }
    
    // Draw Particles
    updateAndDrawParticles();

    ctx.restore();
    
    // Draw Floor Line if visible (visual aid for start)
    if (cameraY < 100) {
        ctx.fillStyle = '#fff'; // Snow floor
        ctx.fillRect(0, CANVAS_HEIGHT - 20 + cameraY, CANVAS_WIDTH, 20);
    }
}

function updateAnimation(dt) {
    player.frameTimer += dt * 0.015; // Speed adjustment
    
    // Frame Count
    const spriteInfo = spriteData[player.state];
    if (!spriteInfo) return;
    
    if (player.frameTimer >= 1) {
        player.frameTimer = 0;
        player.frame = (player.frame + 1) % spriteInfo.frames;
    }
}

function createParticles(x, y, text) {
    for (let i = 0; i < 5; i++) {
        particles.push({
            x: x,
            y: y,
            vx: (Math.random() - 0.5) * 4,
            vy: (Math.random() - 0.5) * 4,
            life: 1.0,
            text: text
        });
    }
}

function updateAndDrawParticles() {
    for (let i = particles.length - 1; i >= 0; i--) {
        let p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        p.life -= 0.02;
        
        // Only draw if life is still positive
        if (p.life > 0) {
        ctx.globalAlpha = p.life;
        ctx.font = '16px Arial';
        ctx.fillStyle = '#fff';
        ctx.fillText(p.text, p.x, p.y);
        ctx.globalAlpha = 1.0;
        }

        if (p.life <= 0) particles.splice(i, 1);
    }
}

function drawSnow() {
    ctx.fillStyle = "rgba(255, 255, 255, 0.8)";
    ctx.beginPath();
    for (let i = 0; i < snowflakes.length; i++) {
        let f = snowflakes[i];
        ctx.moveTo(f.x, f.y);
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2, true);
    }
    ctx.fill();
}

function gameOver() {
    gameRunning = false;
    document.getElementById('final-score').innerText = Math.floor(score);
    document.getElementById('game-over-screen').classList.remove('hidden');
    document.getElementById('hud').classList.add('hidden');
}

function winGame() {
    gameRunning = false;
    document.getElementById('win-screen').classList.remove('hidden');
    document.getElementById('hud').classList.add('hidden');
    document.getElementById('win-final-score').innerText = Math.floor(score);
    
    // Fetch Discount
    fetchDiscount();
}

function shareResult() {
    const text = `Som Vianočný renovátor Techsavers! Dosiahol som skóre ${Math.floor(score)} a prešiel všetkými 11 krokmi. 🎄💻`;
    if (navigator.share) {
        navigator.share({
            title: 'Techsavers Renovator',
            text: text,
            url: window.location.href
        });
    } else {
        alert('Skopírované do schránky: ' + text);
        navigator.clipboard.writeText(text);
    }
}

// API Functions
async function fetchScores() {
    try {
        const response = await fetch(`${API_BASE_URL}/scores`, {
            headers: { 'Accept': 'application/json' }
        });
        const scores = await response.json();
        renderScoreboard(scores);
    } catch (error) {
        console.error('Error fetching scores:', error);
        document.getElementById('scoreboard-list').innerHTML = `<p>${t('noScores')}</p>`;
    }
}

async function submitScore(nickname, btnId) {
    if (!nickname || nickname.trim() === '') {
        alert(t('yourName'));
        return;
    }
    
    const btn = document.getElementById(btnId);
    const originalText = btn ? btn.innerText : 'Odoslať skóre';
    if (btn) {
        btn.innerText = 'Odosielam...';
        btn.disabled = true;
    }
    
    const scoreVal = Math.floor(score);
    console.log(`Submitting score: ${scoreVal} for ${nickname}`);
    
    try {
        const response = await fetch(`${API_BASE_URL}/scores`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                player_nickname: nickname,
                score: scoreVal
            })
        });
        
        if (response.ok) {
            // Track score submission
            pushDataLayerEvent('game_action', 'score_submitted');
            
            // Hide input forms
            document.getElementById('submission-form').classList.add('hidden');
            document.getElementById('win-submission-form').classList.add('hidden');
            
            // Show Scoreboard
            showScoreboard();
        } else {
            const data = await response.json();
            console.error('Submission error:', data);
            alert('Chyba pri odosielaní: ' + (data.message || 'Neznáma chyba'));
        }
    } catch (error) {
        console.error('Error submitting score:', error);
        alert('Nepodarilo sa odoslať skóre. Skontrolujte pripojenie.');
    } finally {
        if (btn) {
            btn.innerText = originalText;
            btn.disabled = false;
        }
    }
}

async function fetchDiscount() {
    try {
        const response = await fetch(`${API_BASE_URL}/discount`, {
            headers: { 'Accept': 'application/json' }
        });
        const data = await response.json();
        document.getElementById('discount-code').innerText = data.discount_code;
        document.getElementById('discount-container').classList.remove('hidden');
    } catch (error) {
        console.error('Error fetching discount:', error);
        // Show container anyway with loading text if API fails
        document.getElementById('discount-container').classList.remove('hidden');
    }
}

function showScoreboard() {
    // Hide other screens
    document.getElementById('game-over-screen').classList.add('hidden');
    document.getElementById('win-screen').classList.add('hidden');
    document.getElementById('start-screen').classList.add('hidden');
    
    document.getElementById('scoreboard-screen').classList.remove('hidden');
    fetchScores();
}

function hideScoreboard() {
    document.getElementById('scoreboard-screen').classList.add('hidden');
    // If game ended, show start screen or just reload
    document.getElementById('start-screen').classList.remove('hidden');
}

function renderScoreboard(scores) {
    const list = document.getElementById('scoreboard-list');
    list.innerHTML = '';
    
    if (scores.length === 0) {
        list.innerHTML = `<p>${t('noScores')}</p>`;
        return;
    }
    
    scores.forEach((s, index) => {
        const div = document.createElement('div');
        div.className = 'score-item';
        div.innerHTML = `
            <span class="score-rank">${index + 1}.</span>
            <span class="score-name">${s.player_nickname}</span>
            <span class="score-value">${s.score}</span>
        `;
        list.appendChild(div);
    });
}
